import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import Loading from 'components/Loading';
import 'e100-react-components/lib/fonts/fonts.css';
import '@deck.gl/widgets/stylesheet.css';

import store from './store';
import App from './pages/app';
import { Translations } from './i18n/Translations';

import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import isBetween from "dayjs/plugin/isBetween";
import minMax from "dayjs/plugin/minMax";

dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(minMax);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Suspense fallback={<Loading position={'fixed'} align={'center'} />}>
    <Provider store={store}>
      <Translations>
        <App />
      </Translations>
    </Provider>
  </Suspense>
);
